/**
 * API сервис для работы с чатом
 */

import { API_BASE_URL } from '../config/constants';

async function parseJson(response) {
    const text = await response.text();
    if (!text) {
        return null;
    }
    try {
        return JSON.parse(text);
    } catch {
        return null;
    }
}

class ChatAPI {
    constructor() {
        this.userId = this.getUserId();
    }

    /**
     * Получает или создает уникальный ID пользователя
     */
    getUserId() {
        let userId = localStorage.getItem('chat_user_id');
        if (!userId) {
            userId = 'user_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
            localStorage.setItem('chat_user_id', userId);
        }
        return userId;
    }

    /**
     * Отправляет сообщение на сервер
     */
    async sendMessage(message, userInfo = {}) {
        try {
            const response = await fetch(`${API_BASE_URL}/chat/message`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    userId: this.userId,
                    message,
                    userInfo
                }),
            });

            if (!response.ok) {
                throw new Error('Ошибка отправки сообщения');
            }

            const data = await parseJson(response);
            if (!data) {
                throw new Error('Ошибка отправки сообщения');
            }
            return data;
        } catch (error) {
            console.error('Ошибка sendMessage:', error);
            throw error;
        }
    }

    /**
     * Получает историю сообщений
     */
    async getMessages() {
        try {
            const response = await fetch(`${API_BASE_URL}/chat/messages/${encodeURIComponent(this.userId)}`);
            const data = await parseJson(response);
            if (!response.ok || !data) {
                return [];
            }
            return data.messages || [];
        } catch {
            return [];
        }
    }

    /**
     * Проверяет статус сервера
     */
    async checkStatus() {
        try {
            const response = await fetch(`${API_BASE_URL}/chat/status`);
            if (!response.ok) {
                return { status: 'offline' };
            }
            const data = await parseJson(response);
            if (!data) {
                return { status: 'offline' };
            }
            return data;
        } catch (error) {
            return { status: 'offline' };
        }
    }

    /**
     * Удаляет сессию пользователя и тему в Telegram
     */
    async deleteSession() {
        try {
            await fetch(`${API_BASE_URL}/chat/session/${encodeURIComponent(this.userId)}`, { method: 'DELETE' });
        } catch (error) {
            console.error('Ошибка deleteSession:', error);
        }
        localStorage.removeItem('chat_user_id');
        this.userId = this.getUserId();
    }

    /**
     * Подписывается на новые сообщения (polling каждые 3 секунды)
     */
    subscribeToMessages(callback) {
        let lastMessageCount = 0;

        const poll = async () => {
            try {
                const messages = await this.getMessages();
                if (messages.length > lastMessageCount) {
                    callback(messages);
                    lastMessageCount = messages.length;
                }
            } catch (error) {
                console.error('Ошибка polling:', error);
            }
        };

        // Запускаем polling каждые 3 секунды
        const intervalId = setInterval(poll, 3000);

        // Возвращаем функцию для отписки
        return () => clearInterval(intervalId);
    }
}

export default new ChatAPI();
